module.exports = __webpack_public_path__ + "img/in.0adf45fe.svg";